import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/h5/loading.gif'


const _withScopeId = n => (_pushScopeId("data-v-18530efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "z-job",
  id: "position",
  "infinite-scroll-distance": 100
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "50"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "50"
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "z-job__name" }
const _hoisted_7 = { class: "z-job__info" }
const _hoisted_8 = { class: "z-job__date" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "z-job__name" }
const _hoisted_11 = { class: "z-job__info" }
const _hoisted_12 = { class: "z-job__date" }
const _hoisted_13 = { class: "loading" }
const _hoisted_14 = {
  key: 1,
  class: "toPosition"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("查看工作机会")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_z_switch = _resolveComponent("z-switch")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_z_empty = _resolveComponent("z-empty")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_z_switch),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.isRefresh,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isRefresh) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      loosing: _withCtx(() => [
        _hoisted_2
      ]),
      loading: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        (_ctx.list && _ctx.list.length !== 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass({ isExpired: _ctx.type == 'myLike' && item.status != 2 }),
                  key: index
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([item.isHotJob == 1 ? 'isHotJob' : ''])
                  }, null, 2),
                  (_ctx.type == 'myLike')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.handleJobClick(item))
                      }, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.deptNameStr && `${item.deptNameStr.split('-')[0]}-`) + _toDisplayString(item.postNameOut) + _toDisplayString(item.workPlaceNameStr && `-${item.workPlaceNameStr.split('-')[1]}`), 1),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.deptNameStr && item.deptNameStr.split('-')[0]) + "｜" + _toDisplayString(item.workPlaceNameStr && item.workPlaceNameStr.split('-')[1]) + "｜" + _toDisplayString(item.positionTypeName), 1),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$dayjs(item.gmtModified).format('YYYY-MM-DD')), 1)
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (_ctx.type == 'myApply')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.handleJobClick(item))
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createTextVNode(_toDisplayString(item.postNameOut) + " ", 1),
                          _createVNode(_component_van_tag, { type: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.status), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.deptName), 1),
                        _createElementVNode("div", _hoisted_12, "投递时间：" + _toDisplayString(_ctx.$dayjs(item.gmtCreate).format('YYYY-MM-DD HH:mm:ss')), 1)
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128)),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createVNode(_component_van_loading, { color: "#999" }, null, 512), [
                  [_vShow, _ctx.hasNextPage]
                ]),
                _withDirectives(_createElementVNode("div", null, "暂无更多职位", 512), [
                  [_vShow, !_ctx.hasNextPage]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.list.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_z_empty, null, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              (_ctx.currentRouteName == 'myApply')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    onClick: _ctx.toPosition
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ])), [
    [_directive_infinite_scroll, _ctx.handleLoad]
  ])
}